export { default } from "./PasswordRequestedConfirmation";
